import React from 'react';
import { workProcessStepsType } from '../../propTypes';

const MilestoneExpandedSteps = ({ steps }) => (
    steps.map(({ title, description, order }) => (
        <div key={order} className="tbody-7 step-container">
            <b>{title}</b>
            <span>{description}</span>
        </div>
    ))
);

MilestoneExpandedSteps.propTypes = {
    steps: workProcessStepsType.isRequired
};

export default MilestoneExpandedSteps;
